import { t } from '@transifex/native'

export type Country = {
  name: string
  code: string
}

export const COUNTRIES: Country[] = [
  { name: t('Afghanistan'), code: 'AF' },
  { name: t('Åland Islands'), code: 'AX' },
  { name: t('Albania'), code: 'AL' },
  { name: t('Algeria'), code: 'DZ' },
  { name: t('American Samoa'), code: 'AS' },
  { name: t('Andorra'), code: 'AD' },
  { name: t('Angola'), code: 'AO' },
  { name: t('Anguilla'), code: 'AI' },
  { name: t('Antarctica'), code: 'AQ' },
  { name: t('Antigua and Barbuda'), code: 'AG' },
  { name: t('Argentina'), code: 'AR' },
  { name: t('Armenia'), code: 'AM' },
  { name: t('Aruba'), code: 'AW' },
  { name: t('Australia'), code: 'AU' },
  { name: t('Austria'), code: 'AT' },
  { name: t('Azerbaijan'), code: 'AZ' },
  { name: t('Bahamas'), code: 'BS' },
  { name: t('Bahrain'), code: 'BH' },
  { name: t('Bangladesh'), code: 'BD' },
  { name: t('Barbados'), code: 'BB' },
  { name: t('Belarus'), code: 'BY' },
  { name: t('Belgium'), code: 'BE' },
  { name: t('Belize'), code: 'BZ' },
  { name: t('Benin'), code: 'BJ' },
  { name: t('Bermuda'), code: 'BM' },
  { name: t('Bhutan'), code: 'BT' },
  { name: t('Bolivia'), code: 'BO' },
  { name: t('Bosnia and Herzegovina'), code: 'BA' },
  { name: t('Botswana'), code: 'BW' },
  { name: t('Bouvet Island'), code: 'BV' },
  { name: t('Brazil'), code: 'BR' },
  { name: t('British Indian Ocean Territory'), code: 'IO' },
  { name: t('Brunei Darussalam'), code: 'BN' },
  { name: t('Bulgaria'), code: 'BG' },
  { name: t('Burkina Faso'), code: 'BF' },
  { name: t('Burundi'), code: 'BI' },
  { name: t('Cambodia'), code: 'KH' },
  { name: t('Cameroon'), code: 'CM' },
  { name: t('Canada'), code: 'CA' },
  { name: t('Cape Verde'), code: 'CV' },
  { name: t('Cayman Islands'), code: 'KY' },
  { name: t('Central African Republic'), code: 'CF' },
  { name: t('Chad'), code: 'TD' },
  { name: t('Chile'), code: 'CL' },
  { name: t('China'), code: 'CN' },
  { name: t('Christmas Island'), code: 'CX' },
  { name: t('Cocos (Keeling) Islands'), code: 'CC' },
  { name: t('Colombia'), code: 'CO' },
  { name: t('Comoros'), code: 'KM' },
  { name: t('Congo'), code: 'CG' },
  { name: t('Congo, The Democratic Republic of the'), code: 'CD' },
  { name: t('Cook Islands'), code: 'CK' },
  { name: t('Costa Rica'), code: 'CR' },
  { name: t("Cote D'Ivoire"), code: 'CI' },
  { name: t('Croatia'), code: 'HR' },
  { name: t('Cuba'), code: 'CU' },
  { name: t('Cyprus'), code: 'CY' },
  { name: t('Czech Republic'), code: 'CZ' },
  { name: t('Denmark'), code: 'DK' },
  { name: t('Djibouti'), code: 'DJ' },
  { name: t('Dominica'), code: 'DM' },
  { name: t('Dominican Republic'), code: 'DO' },
  { name: t('Ecuador'), code: 'EC' },
  { name: t('Egypt'), code: 'EG' },
  { name: t('El Salvador'), code: 'SV' },
  { name: t('Equatorial Guinea'), code: 'GQ' },
  { name: t('Eritrea'), code: 'ER' },
  { name: t('Estonia'), code: 'EE' },
  { name: t('Ethiopia'), code: 'ET' },
  { name: t('Falkland Islands (Malvinas)'), code: 'FK' },
  { name: t('Faroe Islands'), code: 'FO' },
  { name: t('Fiji'), code: 'FJ' },
  { name: t('Finland'), code: 'FI' },
  { name: t('France'), code: 'FR' },
  { name: t('French Guiana'), code: 'GF' },
  { name: t('French Polynesia'), code: 'PF' },
  { name: t('French Southern Territories'), code: 'TF' },
  { name: t('Gabon'), code: 'GA' },
  { name: t('Gambia'), code: 'GM' },
  { name: t('Georgia'), code: 'GE' },
  { name: t('Germany'), code: 'DE' },
  { name: t('Ghana'), code: 'GH' },
  { name: t('Gibraltar'), code: 'GI' },
  { name: t('Greece'), code: 'GR' },
  { name: t('Greenland'), code: 'GL' },
  { name: t('Grenada'), code: 'GD' },
  { name: t('Guadeloupe'), code: 'GP' },
  { name: t('Guam'), code: 'GU' },
  { name: t('Guatemala'), code: 'GT' },
  { name: t('Guernsey'), code: 'GG' },
  { name: t('Guinea'), code: 'GN' },
  { name: t('Guinea-Bissau'), code: 'GW' },
  { name: t('Guyana'), code: 'GY' },
  { name: t('Haiti'), code: 'HT' },
  { name: t('Heard Island and Mcdonald Islands'), code: 'HM' },
  { name: t('Holy See (Vatican City State)'), code: 'VA' },
  { name: t('Honduras'), code: 'HN' },
  { name: t('Hong Kong'), code: 'HK' },
  { name: t('Hungary'), code: 'HU' },
  { name: t('Iceland'), code: 'IS' },
  { name: t('India'), code: 'IN' },
  { name: t('Indonesia'), code: 'ID' },
  { name: t('Iran, Islamic Republic Of'), code: 'IR' },
  { name: t('Iraq'), code: 'IQ' },
  { name: t('Ireland'), code: 'IE' },
  { name: t('Isle of Man'), code: 'IM' },
  { name: t('Israel'), code: 'IL' },
  { name: t('Italy'), code: 'IT' },
  { name: t('Jamaica'), code: 'JM' },
  { name: t('Japan'), code: 'JP' },
  { name: t('Jersey'), code: 'JE' },
  { name: t('Jordan'), code: 'JO' },
  { name: t('Kazakhstan'), code: 'KZ' },
  { name: t('Kenya'), code: 'KE' },
  { name: t('Kiribati'), code: 'KI' },
  { name: t("Korea, Democratic People's Republic of"), code: 'KP' },
  { name: t('Korea, Republic of'), code: 'KR' },
  { name: t('Kuwait'), code: 'KW' },
  { name: t('Kyrgyzstan'), code: 'KG' },
  { name: t("Lao People's Democratic Republic"), code: 'LA' },
  { name: t('Latvia'), code: 'LV' },
  { name: t('Lebanon'), code: 'LB' },
  { name: t('Lesotho'), code: 'LS' },
  { name: t('Liberia'), code: 'LR' },
  { name: t('Libyan Arab Jamahiriya'), code: 'LY' },
  { name: t('Liechtenstein'), code: 'LI' },
  { name: t('Lithuania'), code: 'LT' },
  { name: t('Luxembourg'), code: 'LU' },
  { name: t('Macao'), code: 'MO' },
  { name: t('Macedonia, The Former Yugoslav Republic of'), code: 'MK' },
  { name: t('Madagascar'), code: 'MG' },
  { name: t('Malawi'), code: 'MW' },
  { name: t('Malaysia'), code: 'MY' },
  { name: t('Maldives'), code: 'MV' },
  { name: t('Mali'), code: 'ML' },
  { name: t('Malta'), code: 'MT' },
  { name: t('Marshall Islands'), code: 'MH' },
  { name: t('Martinique'), code: 'MQ' },
  { name: t('Mauritania'), code: 'MR' },
  { name: t('Mauritius'), code: 'MU' },
  { name: t('Mayotte'), code: 'YT' },
  { name: t('Mexico'), code: 'MX' },
  { name: t('Micronesia, Federated States of'), code: 'FM' },
  { name: t('Moldova, Republic of'), code: 'MD' },
  { name: t('Monaco'), code: 'MC' },
  { name: t('Mongolia'), code: 'MN' },
  { name: t('Montenegro'), code: 'ME' },
  { name: t('Montserrat'), code: 'MS' },
  { name: t('Morocco'), code: 'MA' },
  { name: t('Mozambique'), code: 'MZ' },
  { name: t('Myanmar'), code: 'MM' },
  { name: t('Namibia'), code: 'NA' },
  { name: t('Nauru'), code: 'NR' },
  { name: t('Nepal'), code: 'NP' },
  { name: t('Netherlands'), code: 'NL' },
  { name: t('Netherlands Antilles'), code: 'AN' },
  { name: t('New Caledonia'), code: 'NC' },
  { name: t('New Zealand'), code: 'NZ' },
  { name: t('Nicaragua'), code: 'NI' },
  { name: t('Niger'), code: 'NE' },
  { name: t('Nigeria'), code: 'NG' },
  { name: t('Niue'), code: 'NU' },
  { name: t('Norfolk Island'), code: 'NF' },
  { name: t('Northern Mariana Islands'), code: 'MP' },
  { name: t('Norway'), code: 'NO' },
  { name: t('Oman'), code: 'OM' },
  { name: t('Pakistan'), code: 'PK' },
  { name: t('Palau'), code: 'PW' },
  { name: t('Palestinian Territory, Occupied'), code: 'PS' },
  { name: t('Panama'), code: 'PA' },
  { name: t('Papua New Guinea'), code: 'PG' },
  { name: t('Paraguay'), code: 'PY' },
  { name: t('Peru'), code: 'PE' },
  { name: t('Philippines'), code: 'PH' },
  { name: t('Pitcairn'), code: 'PN' },
  { name: t('Poland'), code: 'PL' },
  { name: t('Portugal'), code: 'PT' },
  { name: t('Puerto Rico'), code: 'PR' },
  { name: t('Qatar'), code: 'QA' },
  { name: t('Reunion'), code: 'RE' },
  { name: t('Romania'), code: 'RO' },
  { name: t('Russian Federation'), code: 'RU' },
  { name: t('RWANDA'), code: 'RW' },
  { name: t('Saint Helena'), code: 'SH' },
  { name: t('Saint Kitts and Nevis'), code: 'KN' },
  { name: t('Saint Lucia'), code: 'LC' },
  { name: t('Saint Pierre and Miquelon'), code: 'PM' },
  { name: t('Saint Vincent and the Grenadines'), code: 'VC' },
  { name: t('Samoa'), code: 'WS' },
  { name: t('San Marino'), code: 'SM' },
  { name: t('Sao Tome and Principe'), code: 'ST' },
  { name: t('Saudi Arabia'), code: 'SA' },
  { name: t('Senegal'), code: 'SN' },
  { name: t('Serbia'), code: 'RS' },
  { name: t('Seychelles'), code: 'SC' },
  { name: t('Sierra Leone'), code: 'SL' },
  { name: t('Singapore'), code: 'SG' },
  { name: t('Slovakia'), code: 'SK' },
  { name: t('Slovenia'), code: 'SI' },
  { name: t('Solomon Islands'), code: 'SB' },
  { name: t('Somalia'), code: 'SO' },
  { name: t('South Africa'), code: 'ZA' },
  { name: t('South Georgia and the South Sandwich Islands'), code: 'GS' },
  { name: t('Spain'), code: 'ES' },
  { name: t('Sri Lanka'), code: 'LK' },
  { name: t('Sudan'), code: 'SD' },
  { name: t('Suriname'), code: 'SR' },
  { name: t('Svalbard and Jan Mayen'), code: 'SJ' },
  { name: t('Swaziland'), code: 'SZ' },
  { name: t('Sweden'), code: 'SE' },
  { name: t('Switzerland'), code: 'CH' },
  { name: t('Syrian Arab Republic'), code: 'SY' },
  { name: t('Taiwan, Province of China'), code: 'TW' },
  { name: t('Tajikistan'), code: 'TJ' },
  { name: t('Tanzania, United Republic of'), code: 'TZ' },
  { name: t('Thailand'), code: 'TH' },
  { name: t('Timor-Leste'), code: 'TL' },
  { name: t('Togo'), code: 'TG' },
  { name: t('Tokelau'), code: 'TK' },
  { name: t('Tonga'), code: 'TO' },
  { name: t('Trinidad and Tobago'), code: 'TT' },
  { name: t('Tunisia'), code: 'TN' },
  { name: t('Turkey'), code: 'TR' },
  { name: t('Turkmenistan'), code: 'TM' },
  { name: t('Turks and Caicos Islands'), code: 'TC' },
  { name: t('Tuvalu'), code: 'TV' },
  { name: t('Uganda'), code: 'UG' },
  { name: t('Ukraine'), code: 'UA' },
  { name: t('United Arab Emirates'), code: 'AE' },
  { name: t('United Kingdom'), code: 'GB' },
  { name: t('United States'), code: 'US' },
  { name: t('United States Minor Outlying Islands'), code: 'UM' },
  { name: t('Uruguay'), code: 'UY' },
  { name: t('Uzbekistan'), code: 'UZ' },
  { name: t('Vanuatu'), code: 'VU' },
  { name: t('Venezuela'), code: 'VE' },
  { name: t('Viet Nam'), code: 'VN' },
  { name: t('Virgin Islands, British'), code: 'VG' },
  { name: t('Virgin Islands, U.S.'), code: 'VI' },
  { name: t('Wallis and Futuna'), code: 'WF' },
  { name: t('Western Sahara'), code: 'EH' },
  { name: t('Yemen'), code: 'YE' },
  { name: t('Zambia'), code: 'ZM' },
  { name: t('Zimbabwe'), code: 'ZW' },
]

const countryCache = new Map<string, Country>()

export const getCountryByCode = (code: string): Country => {
  if (countryCache.has(code)) {
    return countryCache.get(code) as Country
  }
  const country = COUNTRIES.find(country => country.code === code) ?? { name: code, code }
  countryCache.set(code, country)
  return country
}

export const getFlagFromCode = (code: string): string => {
  return code.toUpperCase().replace(/./g, char => String.fromCodePoint(char.charCodeAt(0) + 127397))
}
